'use client';

import { Check } from 'lucide-react';

interface FullShareViewFooterProps {
  cancelLabel: string;
  copyLabel: string;
  copied: boolean;
  shareUrl: string | null;
  onClose: () => void;
  onCopy: () => void;
}

export function FullShareViewFooter({
  cancelLabel,
  copyLabel,
  copied,
  shareUrl,
  onClose,
  onCopy,
}: FullShareViewFooterProps) {
  return (
    <div className="shrink-0 flex justify-end gap-2 px-6 py-6">
      <button
        type="button"
        data-hook="share-cancel-footer"
        onClick={onClose}
        className="cursor-pointer rounded-md px-4 py-1.5 text-xs font-semibold text-[#151414] hover:bg-muted"
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        data-hook="copy-link"
        onClick={onCopy}
        disabled={!shareUrl}
        className="flex cursor-pointer items-center gap-1 rounded-md bg-[#151414] px-4 py-1.5 text-xs font-semibold text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {copied ? <Check size={12} /> : null}
        {copyLabel}
      </button>
    </div>
  );
}
